var _defs, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOilTanker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: #06172d;\n      }\n\n      .st2 {\n        fill: none;\n        stroke: #06172d;\n        stroke-width: 2.5px;\n      }\n\n      .st1 {\n        opacity: .2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 65,
    cy: 65,
    r: 65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 40.231,
    y: 28.244,
    width: 49.537,
    height: 13.619
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "58.646 14.441 71.354 14.441 74.189 28.244 55.811 28.244 58.646 14.441"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "65 62.725 28.254 65.746 39.589 112.75 90.411 112.75 101.746 65.746 65 62.725"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "35.076 65.185 35.076 41.863 94.924 41.863 94.924 65.185"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65.008,
    y1: 49.145,
    x2: 65.01,
    y2: 71.54
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 74.189,
    y1: 27.52,
    x2: 87.791,
    y2: 41.122
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65,
    y1: 28.463,
    x2: 78.337,
    y2: 41.801
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.446,100.892c-1.619,2.154-4.404,3.231-8.357,3.231s-6.737-1.077-8.356-3.231-2.429-5.526-2.429-10.116.81-7.999,2.429-10.23c1.619-2.23,4.404-3.346,8.356-3.346s6.738,1.115,8.357,3.346c1.619,2.231,2.428,5.642,2.428,10.23s-.809,7.962-2.428,10.116ZM50.863,97.525c.752,1.339,2.16,2.008,4.226,2.008s3.475-.669,4.227-2.008c.752-1.338,1.129-3.581,1.129-6.73s-.383-5.437-1.148-6.865c-.764-1.428-2.167-2.142-4.207-2.142s-3.441.714-4.207,2.142c-.765,1.429-1.147,3.717-1.147,6.865s.376,5.393,1.129,6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.786,82.323v-4.666h19.122v4.666h-6.884v21.341h-5.277v-21.341h-6.961Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilTanker);
export default __webpack_public_path__ + "static/media/oil_tanker.192d4221d0cc9ccd4cc834efb534e46b.svg";
export { ForwardRef as ReactComponent };